import * as React from 'react';
import { Radio, Input } from 'antd';
import { get } from 'lodash';
import intl from 'react-intl-universal';

import { Config } from '@src/apps/interview-questionnaire/services/model';
import { RadioChangeEvent } from 'antd/lib/radio/interface';

import './index.less';

export interface SelectItemProps {
  value: [string, string];
  onChange?: (value: [string, string]) => void;
  config: Config;
  id?: string;
  desc?: string;
  onFocus?: (value: any) => void;
  resetError?: () => void;
  errorMsg?: string;
}

interface ProcessedOption {
  label: string;
  value: string;
}

const { Group } = Radio;
const { useRef } = React;
const SelectItem: React.FC<SelectItemProps> = ({
  value,
  onChange,
  config,
  id,
  desc,
  resetError,
  errorMsg,
  ...props
}) => {
  const [checked, specificReason] = value || [];
  const reasonsCacheRef = useRef<Record<string, string>>({});
  const { options, requireReasonMap } = get(config, 'options', []).reduce<{
    options: ProcessedOption[];
    requireReasonMap: Record<string, string>;
  }>(
    (res, item) => {
      if (item.require_reason) {
        res.requireReasonMap[get(item, 'key')] = get(item, 'reason_desc.i18n_name');
      }
      res.options.push({ label: get(item, 'name.i18n_name', ''), value: get(item, 'key') });
      return res;
    },
    { options: [], requireReasonMap: {} }
  );
  const handleChange = (e: RadioChangeEvent) => {
    const newValue = e.target.value;

    resetError && resetError();

    // Save current input before switching
    if (checked) {
      reasonsCacheRef.current[checked] = specificReason || '';
    }

    // Restore previous input for the new option if exists
    const nextReason = reasonsCacheRef.current[newValue] || '';

    onChange && onChange([newValue, nextReason]);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    resetError && resetError();
    const value = e.target.value;
    if (checked) {
      reasonsCacheRef.current[checked] = value;
    }
    onChange && onChange([checked, value]);
  };
  return (
    <div className="mobile-questionnaire__form__select-wrapper" id={id}>
      {desc && <div className="desc">{desc}</div>}
      <Group value={checked} onChange={handleChange} {...props}>
        {options.map((item) => (
          <div key={item.value}>
            <p>
              <Radio value={item.value}>{item.label}</Radio>
            </p>
            {checked === item.value && requireReasonMap[item.value] && (
              <>
                <Input.TextArea
                  placeholder={requireReasonMap[checked]}
                  value={specificReason}
                  onChange={handleInputChange}
                  className="questionnaire__form__select__input--mobile"
                  error={!!(errorMsg && !specificReason)}
                  style={errorMsg && !specificReason ? { borderColor: '#ff4d4f' } : undefined}
                />
                {errorMsg && !specificReason && (
                  <div className="error-msg">
                    {intl.get('pleaseSupplementExplanation')}
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </Group>
    </div>
  );
};

export default SelectItem;
